import React, { useEffect } from 'react';
import { generalStore } from '../../store';

import SupportList from '../../components/supportList/SupportList';

import { useTranslation } from 'react-i18next';

const SupportView = () => {
    const { t, i18n } = useTranslation();
    const { setPageName } = generalStore();

    useEffect(() => {
        setPageName(t('support_title'));
    }, [i18n.language]);

    return (
        <div className="b-support-view">
            <SupportList />
        </div>
    );
};

export default SupportView;
